import { createAction } from '@reduxjs/toolkit';

export const requestCreatePost = createAction('market-buzz/createPost');
export const requestViewPosts = createAction('market-buzz/viewPosts');
export const requestUpdatePost = createAction('market-buzz/updatePost');
export const requestDeletePost = createAction('market-buzz/deletePost');
export const requestPopulateMarketBuzzFilter = createAction('market-buzz/populateMarketBuzzFilter');
export const requestCreateReaction = createAction('market-buzz/createReaction');
export const requestViewReactions = createAction('market-buzz/viewReactions');
export const requestRetrieveChat = createAction('market-buzz/retrieveChat');
export const requestCreateComment = createAction('market-buzz/createComment');
export const requestViewComments = createAction('market-buzz/viewComments');
export const requestUpdateComment = createAction('market-buzz/updateComment');
